module.exports = __webpack_public_path__ + "static/media/star.3d5f325b.svg";